export const productsObjOne = {
  lightBg: false,
  lightText: true,
  lightTopLine: true,
  lightTextDesc: true,
  topLine: 'Blog',
  headline: 'Glasses History',
  description:
    'The first glasses were made up of two lenses mounted in circles of wood or horn, joined by a rivet and placed on the nose. The biconvex lenses solved near vision defects, such as presbyopia.',
  buttonLabel: 'Learn more',
  imgStart: 'start',
  img: require('../../images/svg-10.svg'),
  alt: 'Credit Card'
};

export const productsObjTwo = {
  lightBg: true,
  lightText: false,
  lightTopLine: false,
  lightTextDesc: false,
  topLine: 'Blog',
  headline: 'A Brief History of Augmented Reality',
  description:
    'Believe it or not, augmented reality tech dates back to the 60s.',
  buttonLabel: 'Learn More',
  imgStart: '',
  img: require('../../images/svg-4.svg'),
  alt: 'Vault'
};

export const productsObjThree = {
  lightBg: false,
  lightText: true,
  lightTopLine: true,
  lightTextDesc: true,
  topLine: 'Devlog',
  headline: 'OpenCV integration',
  description:
    'We added  OpenCV to our code to speed up 3X our image processing.',
  buttonLabel: 'Learn more',
  imgStart: 'start',
  img: require('../../images/svg-1.svg'),
  alt: 'Credit Card'
};
